// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"components-base-Backdrop-Backdrop__backdrop--JiDJB"};